import { render, staticRenderFns } from "./SearchOrders.vue?vue&type=template&id=6a882c26&scoped=true&"
import script from "./SearchOrders.vue?vue&type=script&lang=js&"
export * from "./SearchOrders.vue?vue&type=script&lang=js&"
import style0 from "./SearchOrders.vue?vue&type=style&index=0&id=6a882c26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a882c26",
  null
  
)

export default component.exports